import { Component, OnInit } from "@angular/core";
import { ModalController, NavParams, IonicModule } from "@ionic/angular";
import { interval, map } from "rxjs";
//import { bounceIn } from "src/app/animations/custom.animation";
import { SyndicateLeaveFinalComponent } from "../syndicate-leave-final/syndicate-leave-final.component";
import { SyndicateRepositoryService } from "../syndicate-repository.service";
import { bounceIn, fadeInbottomRight, slideInUp } from "src/app/animations/custom.animation";
import { MatDialog } from "@angular/material/dialog";
import { FreeWeekConfirmationComponent } from "src/app/components/free-week-confirmation/free-week-confirmation.component";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { AuthService } from "@core/auth.service";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { PaymentService } from "src/app/services/payment.service";
import { MixpanelService } from "src/app/services/mixpanel.service";
import { HeaderComponent } from "../../../components/header/header.component";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: "app-take-holiday",
    templateUrl: "./take-holiday.component.html",
    styleUrls: ["./take-holiday.component.scss"],
    animations: [fadeInbottomRight, slideInUp, bounceIn],
    standalone: true,
    imports: [
        HeaderComponent,
        IonicModule,
        MatProgressSpinner,
        MatIcon,
        TranslatePipe,
    ],
})
export class TakeHolidayComponent implements OnInit {
  pageTitle = "Leave syndicate";
  syndicate: any;
  tookHolidaySuccess: boolean;
  tookHolidayError: boolean;
  spinnerAnimation: boolean;
  progressBar: number;
  timer$: any;
  sub: any;
  proceed = true;
  message: any;

  constructor(
    // private dialog: MatDialogRef<FreeWeekConfirmationComponent>,
    private navParams: NavParams,
    private modalCtrl: ModalController,
    private syndicateService: SyndicateRepositoryService,
    private matDialog: MatDialog,
    public translate: TranslateService,
    private authService: AuthService,
    private GTMSegment: GTMSegmentService,
    private mixpanelService: MixpanelService,
    private paymentService: PaymentService
  ) {}

  ngOnInit() {
    this.syndicate = this.navParams?.data.syndicateData;
    this.translate.get(["take-holiday.pageTitle"]).subscribe((res: string) => {
      this.pageTitle = res["take-holiday.pageTitle"];
    });
  }

  startSpinner() {
    this.spinnerAnimation = true;
    this.progressBar = 0;
    this.timer$ = interval(20);
    this.sub = this.timer$?.subscribe(
      (sec) => {
        this.progressBar = 0 + sec;
      },
      (err) => {
        return err;
      }
    );
  }

  takePaymentHoliday() {
    this.GTMSegment.HotJarEvent("payment_holiday_clicked");
        this.syndicateService
      .getSyndicateHoliday(
        this.syndicate?.id
          ? this.syndicate?.id
          : this.syndicate?.encrypted_id
          ? this.syndicate?.encrypted_id
          : this.syndicate?.psId
      )
      .subscribe(
        (data) => {
          this.progressBar === 100;
          this.sub?.unsubscribe();
          if (data?.status === "rejected") {
            this.authService.getConstantsMsg(data?.error_code).then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Something went wrong!",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            }).catch((err) => {
              return err;
            });
            this.tookHolidayError = true;
            setTimeout(() => {
              this.spinnerAnimation = false;
              this.proceed = false;
              setTimeout(() => {
                this.proceed = true;
              }, 2000);
            }, 300);
            return;
          }
          if (data && data?.response && data?.response?.status === "SUCCESS") {
            this.triggerEventOnHolidayActivation(this.syndicate?.id
              ? this.syndicate?.id
              : this.syndicate?.encrypted_id
              ? this.syndicate?.encrypted_id
              : this.syndicate?.psId);
            const msg = this.matDialog.open(FreeWeekConfirmationComponent, {
              height: "68%",
            });
            msg.afterClosed().subscribe(
              () => {
                this.modalCtrl.dismiss(true).catch((err) => {
                  return err;
                });
              },
              (err) => {
                return err;
              }
            );
          } else {
            if (!data || !data?.response || !data?.response?.message) return;
            this.message = data?.response?.message;
            this.tookHolidayError = true;
          }

          setTimeout(() => {
            this.spinnerAnimation = false;
            this.proceed = false;
            setTimeout(() => {
              this.proceed = true;
            }, 2000);
          }, 300);
        },
        (err) => {
          return err;
        }
      );
  }

  backToLeaveSyndicate() {
    this.modalCtrl.dismiss().catch((err) => {
      return err;
    });
  }

  async leave() {
    const leaveSyndicate = await this.modalCtrl.create({
      component: SyndicateLeaveFinalComponent,
      cssClass: "modal-fullScreen",
      componentProps: { syndicateData: this.syndicate },
    });
    leaveSyndicate.onDidDismiss().then((res) => {
      if (!res || !res.data) return;
      if (res && res?.data.leaveFinal) {
        setTimeout(() => {
          this.modalCtrl.dismiss({ leaveFinal: true }).catch((err) => {
            return err;
          });
        }, 100);
      }
    }).catch((error) => {
      return error;
    });
    return await leaveSyndicate.present();
  }

  triggerEventOnHolidayActivation(sid) {
    this.paymentService
        .getSyndicateInfo(sid)
        .pipe(
          map((detail: any) => {
            const syndicateInfo = detail?.data();
            if(syndicateInfo) {
              this.mixpanelService.trackPaymentHoliday(syndicateInfo)
            }
          })
        )?.subscribe();
  }
}
